export default __webpack_public_path__ + "static/media/blinker.418ae9d4.png";